import * as React from 'react';

import { ProgressBar } from 'react-aria-components';

import { Typography } from '../typography';

export type UploadProgressProps = React.HTMLAttributes<HTMLDivElement> & {
  progress: number;
  messageDuringProgress: string;
};

export const UploadProgress = React.forwardRef<
  HTMLDivElement,
  UploadProgressProps
>(({ progress, messageDuringProgress, ...props }, ref) => {
  return (
    <div
      ref={ref}
      className="border-table-border flex h-40 w-full flex-col items-center justify-center rounded-md border border-dashed px-16"
      {...props}
    >
      <Typography className="text-onLight-medium" variant="h4">
        {messageDuringProgress}
      </Typography>
      <div className="mt-3 flex w-full items-center justify-center">
        <ProgressBar
          value={progress}
          className="flex w-full flex-row items-center justify-center"
        >
          {({ percentage, valueText }) => (
            <>
              <div className="top-[50%] h-1 w-full translate-y-[-50%] transform rounded-full bg-gray-300">
                <div
                  className="bg-additional-nephritis absolute top-[50%] h-1 translate-y-[-50%] transform rounded-full"
                  style={{ width: `${percentage}%` }}
                />
              </div>
              <Typography
                className="text-onLight-medium ml-1 flex-1"
                variant="h6"
              >
                {valueText}
              </Typography>
            </>
          )}
        </ProgressBar>
      </div>
    </div>
  );
});

UploadProgress.displayName = 'UploadProgress';
